var map = {
	"./0xA0c9a4ebC96737E8f9f61A88D6361Bb26250a068.svg": "./src/assets/images/0xA0c9a4ebC96737E8f9f61A88D6361Bb26250a068.svg",
	"./2020.gif": "./src/assets/images/2020.gif",
	"./6.jpg": "./src/assets/images/6.jpg",
	"./BakeTwitter.webp": "./src/assets/images/BakeTwitter.webp",
	"./HOTBOXOG_IROBANNER.png": "./src/assets/images/HOTBOXOG_IROBANNER.png",
	"./HOTBOXOG_IRO_BG.png": "./src/assets/images/HOTBOXOG_IRO_BG.png",
	"./Homeimg.jpeg": "./src/assets/images/Homeimg.jpeg",
	"./IMG_5550.jpg": "./src/assets/images/IMG_5550.jpg",
	"./IMG_5551.jpg": "./src/assets/images/IMG_5551.jpg",
	"./IMG_6362_JPG.jpeg": "./src/assets/images/IMG_6362_JPG.jpeg",
	"./TEAsWAP.jpeg": "./src/assets/images/TEAsWAP.jpeg",
	"./TSA Home Banner.jpg": "./src/assets/images/TSA Home Banner.jpg",
	"./TSAWeb3MusicBox.png": "./src/assets/images/TSAWeb3MusicBox.png",
	"./Whostheboss.png": "./src/assets/images/Whostheboss.png",
	"./arrow-down-blue.svg": "./src/assets/images/arrow-down-blue.svg",
	"./arrow-down-grey.svg": "./src/assets/images/arrow-down-grey.svg",
	"./arrow-right-white.png": "./src/assets/images/arrow-right-white.png",
	"./arrow-right.svg": "./src/assets/images/arrow-right.svg",
	"./big_unicorn.png": "./src/assets/images/big_unicorn.png",
	"./binanceWallet.png": "./src/assets/images/binanceWallet.png",
	"./blindbox.png": "./src/assets/images/blindbox.png",
	"./blp_logo.png": "./src/assets/images/blp_logo.png",
	"./blue-loader.svg": "./src/assets/images/blue-loader.svg",
	"./bnb.svg": "./src/assets/images/bnb.svg",
	"./canjun1.webp": "./src/assets/images/canjun1.webp",
	"./caojun2.webp": "./src/assets/images/caojun2.webp",
	"./circle-grey.svg": "./src/assets/images/circle-grey.svg",
	"./circle.svg": "./src/assets/images/circle.svg",
	"./coinbaseWalletIcon.svg": "./src/assets/images/coinbaseWalletIcon.svg",
	"./coingecko.png": "./src/assets/images/coingecko.png",
	"./coingecko1.png": "./src/assets/images/coingecko1.png",
	"./dropdown-blue.svg": "./src/assets/images/dropdown-blue.svg",
	"./dropdown.svg": "./src/assets/images/dropdown.svg",
	"./dropup-blue.svg": "./src/assets/images/dropup-blue.svg",
	"./ethereum-logo.png": "./src/assets/images/ethereum-logo.png",
	"./flame.jpeg": "./src/assets/images/flame.jpeg",
	"./fortmaticIcon.png": "./src/assets/images/fortmaticIcon.png",
	"./grid_image7.jpg": "./src/assets/images/grid_image7.jpg",
	"./grid_img1.webp": "./src/assets/images/grid_img1.webp",
	"./grid_img2.jpeg": "./src/assets/images/grid_img2.jpeg",
	"./grid_img2.webp": "./src/assets/images/grid_img2.webp",
	"./grid_img3.jpeg": "./src/assets/images/grid_img3.jpeg",
	"./grid_img3.webp": "./src/assets/images/grid_img3.webp",
	"./grid_img4.webp": "./src/assets/images/grid_img4.webp",
	"./grid_img5.webp": "./src/assets/images/grid_img5.webp",
	"./grid_img6.webp": "./src/assets/images/grid_img6.webp",
	"./home_page_logo.png": "./src/assets/images/home_page_logo.png",
	"./icashrewards.png": "./src/assets/images/icashrewards.png",
	"./icashrewards.webp": "./src/assets/images/icashrewards.webp",
	"./instgram_icon.png": "./src/assets/images/instgram_icon.png",
	"./instgram_icon.webp": "./src/assets/images/instgram_icon.webp",
	"./link.svg": "./src/assets/images/link.svg",
	"./linktr_icon.png": "./src/assets/images/linktr_icon.png",
	"./linktr_icon.webp": "./src/assets/images/linktr_icon.webp",
	"./logo.png": "./src/assets/images/logo.png",
	"./magnifying-glass.svg": "./src/assets/images/magnifying-glass.svg",
	"./menu.svg": "./src/assets/images/menu.svg",
	"./metamask.png": "./src/assets/images/metamask.png",
	"./noise.png": "./src/assets/images/noise.png",
	"./opensea.png": "./src/assets/images/opensea.png",
	"./partners-499block.png": "./src/assets/images/partners-499block.png",
	"./partners-4chan.png": "./src/assets/images/partners-4chan.png",
	"./partners-aave.png": "./src/assets/images/partners-aave.png",
	"./partners-bancor.png": "./src/assets/images/partners-bancor.png",
	"./partners-bitkeep.png": "./src/assets/images/partners-bitkeep.png",
	"./partners-bitribe.png": "./src/assets/images/partners-bitribe.png",
	"./partners-deepchain.png": "./src/assets/images/partners-deepchain.png",
	"./partners-jfi.png": "./src/assets/images/partners-jfi.png",
	"./partners-marsfinance.png": "./src/assets/images/partners-marsfinance.png",
	"./partners-mathwallet.png": "./src/assets/images/partners-mathwallet.png",
	"./partners-roark.png": "./src/assets/images/partners-roark.png",
	"./partners-safepal.png": "./src/assets/images/partners-safepal.png",
	"./partners-tokenpocket.png": "./src/assets/images/partners-tokenpocket.png",
	"./partners-trustwallet.png": "./src/assets/images/partners-trustwallet.png",
	"./partners-v.png": "./src/assets/images/partners-v.png",
	"./partners-yfii.png": "./src/assets/images/partners-yfii.png",
	"./penguinbrothers.png": "./src/assets/images/penguinbrothers.png",
	"./plus-blue.svg": "./src/assets/images/plus-blue.svg",
	"./plus-grey.svg": "./src/assets/images/plus-grey.svg",
	"./portisIcon.png": "./src/assets/images/portisIcon.png",
	"./question-mark.svg": "./src/assets/images/question-mark.svg",
	"./question.svg": "./src/assets/images/question.svg",
	"./read_medium.jpeg": "./src/assets/images/read_medium.jpeg",
	"./sign/coming.jpg": "./src/assets/images/sign/coming.jpg",
	"./sign/coming.webp": "./src/assets/images/sign/coming.webp",
	"./sign/comingsoon.png": "./src/assets/images/sign/comingsoon.png",
	"./sign/ended.jpg": "./src/assets/images/sign/ended.jpg",
	"./sign/ended.png": "./src/assets/images/sign/ended.png",
	"./sign/new.jpg": "./src/assets/images/sign/new.jpg",
	"./sign/new.png": "./src/assets/images/sign/new.png",
	"./sign/new.webp": "./src/assets/images/sign/new.webp",
	"./spinner.svg": "./src/assets/images/spinner.svg",
	"./swap_logo.png": "./src/assets/images/swap_logo.png",
	"./teaswap-logo-single.png": "./src/assets/images/teaswap-logo-single.png",
	"./teaswap-logo.png": "./src/assets/images/teaswap-logo.png",
	"./telegram_icon.png": "./src/assets/images/telegram_icon.png",
	"./telegram_icon.webp": "./src/assets/images/telegram_icon.webp",
	"./token-list/lists-dark.png": "./src/assets/images/token-list/lists-dark.png",
	"./token-list/lists-light.png": "./src/assets/images/token-list/lists-light.png",
	"./token-logo.png": "./src/assets/images/token-logo.png",
	"./token.png": "./src/assets/images/token.png",
	"./tokenSATO.webp": "./src/assets/images/tokenSATO.webp",
	"./tokenTSA.webp": "./src/assets/images/tokenTSA.webp",
	"./trustWallet.png": "./src/assets/images/trustWallet.png",
	"./twitter_icon.png": "./src/assets/images/twitter_icon.png",
	"./twitter_icon.webp": "./src/assets/images/twitter_icon.webp",
	"./walletConnectIcon.svg": "./src/assets/images/walletConnectIcon.svg",
	"./x.svg": "./src/assets/images/x.svg",
	"./xl_uni.png": "./src/assets/images/xl_uni.png",
	"./xtinct.png": "./src/assets/images/xtinct.png",
	"./youtube.png": "./src/assets/images/youtube.png",
	"./yun.png": "./src/assets/images/yun.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images sync recursive ^\\.\\/.*$";